import { render } from "./Slide5.vue?vue&type=template&id=73b09f3c&scoped=true"
import script from "./Slide5.vue?vue&type=script&lang=js"
export * from "./Slide5.vue?vue&type=script&lang=js"

import "./Slide5.vue?vue&type=style&index=0&id=73b09f3c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b09f3c"]])

export default __exports__